<template>
  <div id="salemarket">
    <my-header></my-header>
    <div class="pd10">
      <div class="sale-market">
        <div v-if="show_header">
          <sale-market-head></sale-market-head>
        </div>
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name: 'SaleMarket', params: { }}">{{'Sale Market'|translate}}</router-link>
          </li>
          <li>{{'Cart'|translate}}</li>
        </ol>
        <loading v-if="carts == null" class="mt10 text-center" :text="'Please wait'|translate"></loading>
        <div
          v-if="carts != null && carts.length == 0"
          class="alert alert-warning"
          role="alert"
        >{{'No cart'|translate}}</div>
        <div class="list-varriants" v-if="carts!= null">
          <ul class="list-group">
            <li class="list-group-item" v-for="(cart) in carts" :key="cart.id">
              <div class="row">
                  <div class="col-md-9 col-xs-9">
                    <p>
                      <router-link
                        :to="{ name: 'SaleAdMarketDetail', params: { ad_id: cart.id}}"
                      >{{cart.varriant_name}}</router-link>

                      :
                      {{toCommas(cart.price)}} X {{cart.quantity}} = {{ toCommas(cart.price * cart.quantity) }} {{'price_unit'|translate}}
                    </p>
                      <p>
                        <i class="fas fa-truck"></i>
                        {{cart.source_name}} ({{cart.source_type|translate}})
                      </p>
                  </div>
                  <div class="col-md-3 col-xs-3">
                    <button class="btn btn-danger" v-on:click="removeItem(cart)">{{'Remove'|translate}}</button>
                  </div>
              </div>

                
            </li>
          </ul>
          <p class="mt10">
            <strong>{{'Estimate total price'|translate}}</strong>
            : {{toCommas(totalPrice)}} {{'price_unit'|translate}}
          </p>
        </div>

        <div class="panel panel-info mt20" v-if="user && carts && carts.length > 0">
          <div class="panel-heading">{{'Order information'|translate}}</div>
          <div class="panel-body">
            <form v-on:submit.prevent="makeOrder()">
              <div class="row">
                <div class="col-md-6 mt20">
                  <label>Điện thoại:</label>
                  <input
                    v-model="order_item.phone"
                    ref="phone"
                    required
                    :placeholder="'Input phone number'|translate"
                    class="form-control"
                  />
                </div>
                <div class="col-md-6 mt20">
                  <label>Email:</label>
                  <input
                    type="email"
                    v-model="order_item.email"
                    ref="email"
                    required
                    :placeholder="'Input email'|translate"
                    class="form-control"
                  />
                </div>

                <div class="col-md-12 mt20">
                  <label>{{'Address'|translate}}:</label>
                  <input
                    type="address"
                    class="form-control"
                    required
                    :placeholder="'Address'|translate"
                    v-model="order_item.address"
                  />
                </div>
              </div>

              <button class="btn btn-primary mt20" type="submit" :disabled="ordering">
                <i v-if="ordering" class="fas fa-spinner fa-spin"></i>
                {{'Place an order'|translate}}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";
import SaleMarketHead from "@/components/SaleMarket/SaleMarketHead";
export default {
  name: "SaleMarket",
  components: {
    MyHeader,
    Loading,
    SaleMarketHead
  },
  data() {
    let data = {
      carts: null,
      ordering: false,
      user: null,
      show_header: true,
      order_item: {
        address: ""
      }
    };

    return data;
  },
  computed: {
    totalPrice() {
      if (!this.carts) return 0;
      let total = 0;
      this.carts.forEach(element => {
        total += element.price * element.quantity;
      });
      return total;
    }
  },
  methods: {
    toCommas(value) {
      return Utils.toCommas(value);
    },
    makeOrder() {
      Utils.request(this, true, "salemarket")
        .post("/makeOrder", this.order_item)
        .then(response => {
          let data = response.data;
          if (data.status == "ok") {
            this.$alertify.alertWithTitle(
              this.$t("Confirm"),
              this.$t("Your order is placed successfully")
            );
            this.carts = [];
            this.show_header = false;
            setTimeout(() => {
              this.show_header = true;
            }, 10);
          }else{
            Utils.showError(this,data.data);
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    getListCarts() {
      console.log("on get list");
      Utils.request(this, true, "salemarket")
        .get(`/listCart/?is_full=1`)
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            this.carts = data.data.list;
          }
        })
        .catch(error => {
          this.working = false;
          Utils.showErrorMessage(this, error.response);
        });
      return;
    },
    removeItem(cart){
      let data = {
        cart_item_id: cart.cart_item_id,
        action: "remove"
      };

      Utils.request(this, true, "salemarket")
        .post("/toggleToCart", data)
        .then(response => {
          let data = response.data;
          if (data.status == "ok") {
            this.getListCarts();
          } else {
            this.$alertify.alertWithTitle(this.$t("Error"), this.$t(data.data));
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    }
  },
  mounted() {
    this.user = Utils.getUser(this);
    if (this.user) {
      this.order_item.phone = this.user.phone;
      this.order_item.email = this.user.email;
    }
    this.getListCarts();
  },
  beforeDestroy() {}
};
</script>



// WEBPACK FOOTER //
// src/components/SaleMarket/SaleMarkeCart.vue